import { withInstall } from '@jdesign-vue/utils'
import TimePicker from './src/time-picker'
import CommonPicker from './src/common/picker.vue'
import TimePickPanel from './src/time-picker-com/panel-time-pick.vue'

export * from './src/utils'
export * from './src/constants'
export * from './src/common/props'

export const JdTimePicker = withInstall(TimePicker)

export { CommonPicker, TimePickPanel }
export default JdTimePicker
